import { P } from './palette';
import type { Direction, Vehicle } from '../game/state';

export const FROG_REST = [
  '..g......g..','..gg....gg..','.ggGg..gGgg.','..gGGGGGGg..','...GGGGGG...',
  '..gGGGGGGg..','.ggGGGGGGgg.','g.gGGGGGGg.g','..gGGGGGGg..','..gGGGGGGg..',
  '.gg..GG..gg.','gg...GG...gg','g..........g',
];
const FROG_HOP = [
  'g..........g','gg........gg','.gg..gg..gg.','..gGGGGGGg..','...GGGGGG...',
  '...GGGGGG...','..gGGGGGGg..','.ggGGGGGGgg.','gggGGGGGGggg','g..GGGGGG..g',
  '...gGGGGg...','..gg....gg..','.gg......gg.','gg........gg',
];
export function pixels(ctx:CanvasRenderingContext2D, data:readonly string[],x:number,y:number,colors:Record<string,string>,scale=1):void {
  data.forEach((row,j)=>[...row].forEach((c,i)=>{const color=colors[c];if(color){ctx.fillStyle=color;ctx.fillRect(Math.round(x+i*scale),Math.round(y+j*scale),scale,scale);}}));
}
export function drawFrog(ctx:CanvasRenderingContext2D,x:number,y:number,direction:Direction='up',jump=false,lady=false,scale=1):void {
  const sprite=jump?FROG_HOP:FROG_REST;
  const angle={up:0,right:Math.PI/2,down:Math.PI,left:-Math.PI/2}[direction];
  ctx.save();ctx.translate(Math.round(x),Math.round(y));ctx.rotate(angle);
  if(scale<1){
    pixels(ctx,['gG...Gg','gGGGGGg','.GGGGG.','gGGGGGg','.GGGGG.','gg.G.gg','g.....g'],-3,-3,{g:lady?P.purple:P.darkGreen,G:lady?'#e686df':P.green});
    ctx.fillStyle=P.white;ctx.fillRect(-2,-2,1,1);ctx.fillRect(2,-2,1,1);ctx.restore();return;
  }
  pixels(ctx,sprite,-6*scale,-7*scale,{g:lady?P.purple:P.darkGreen,G:lady?'#e686df':P.green},scale);
  ctx.fillStyle=P.white;ctx.fillRect(-3*scale,-4*scale,2*scale,2*scale);ctx.fillRect(2*scale,-4*scale,2*scale,2*scale);
  ctx.fillStyle=P.black;ctx.fillRect(-2*scale,-4*scale,scale,scale);ctx.fillRect(2*scale,-4*scale,scale,scale);
  ctx.restore();
}
export function drawCar(ctx:CanvasRenderingContext2D,v:Vehicle):void {
  const x=Math.round(v.x),y=Math.round(v.y);
  ctx.save();ctx.translate(x,y);if(v.speed<0){ctx.translate(v.w,0);ctx.scale(-1,1);}
  const color={car:P.yellow,sedan:P.red,buggy:P.purple,race:P.white,truck:P.white}[v.kind];
  ctx.fillStyle='#555476';ctx.fillRect(3,-7,4,2);ctx.fillRect(v.w-7,-7,4,2);ctx.fillRect(3,5,4,2);ctx.fillRect(v.w-7,5,4,2);
  ctx.fillStyle=color;
  if(v.kind==='truck') {
    ctx.fillRect(1,-5,v.w-11,10);ctx.fillRect(v.w-9,-5,8,10);
    ctx.fillStyle=P.blue;ctx.fillRect(v.w-5,-4,2,8);
    ctx.fillStyle='#9998c4';for(let i=4;i<v.w-11;i+=4)ctx.fillRect(i,-4,1,8);
    ctx.fillStyle=P.red;ctx.fillRect(0,-3,2,6);
  } else if(v.kind==='race') {
    ctx.fillRect(0,-5,3,10);ctx.fillRect(v.w-3,-6,2,12);ctx.fillRect(2,-2,v.w-3,4);ctx.fillRect(5,-4,6,8);
    ctx.fillStyle=P.red;ctx.fillRect(1,-1,v.w-1,2);ctx.fillStyle=P.blue;ctx.fillRect(7,-2,3,4);
  } else {
    ctx.fillRect(1,-4,v.w-2,8);ctx.fillRect(4,-6,v.w-8,12);ctx.fillRect(0,-2,v.w,4);
    ctx.fillStyle=P.blue;ctx.fillRect(Math.floor(v.w*0.55),-4,3,8);ctx.fillRect(4,-3,2,6);
    ctx.fillStyle=P.white;ctx.fillRect(v.w-2,-3,1,2);ctx.fillRect(v.w-2,2,1,2);
    ctx.fillStyle='#351d2b';ctx.fillRect(0,-3,1,2);ctx.fillRect(0,2,1,2);
  }
  ctx.restore();
}
export function drawLog(ctx:CanvasRenderingContext2D,x:number,y:number,w:number):void {
  x=Math.round(x);y=Math.round(y);
  ctx.fillStyle=P.logDark;ctx.fillRect(x,y-5,w,11);
  ctx.fillStyle=P.log;ctx.fillRect(x+1,y-4,w-2,8);ctx.fillRect(x+3,y-6,w-6,1);
  ctx.fillStyle=P.logLight;ctx.fillRect(x+3,y-4,w-6,1);ctx.fillRect(x+3,y+4,w-6,1);
  for(let i=8;i<w-5;i+=17){ctx.fillRect(x+i,y-2,8,1);ctx.fillStyle=P.logDark;ctx.fillRect(x+i-3,y+1,7,1);ctx.fillStyle=P.logLight;}
  ctx.fillStyle=P.logLight;ctx.fillRect(x+1,y-2,2,5);ctx.fillRect(x+w-3,y-2,2,5);
  ctx.fillStyle=P.logDark;ctx.fillRect(x+2,y,1,2);ctx.fillRect(x+w-3,y-1,1,2);
}
export function drawTurtles(ctx:CanvasRenderingContext2D,x:number,y:number,w:number,phase:string,frame:number):void {
  if(phase==='submerged') {
    ctx.fillStyle='#284aa0';for(let i=6;i<w;i+=14)ctx.fillRect(Math.round(x+i),y,3,1);return;
  }
  for(let i=0;i<w;i+=14){
    const cx=Math.round(x+i),cy=Math.round(y);
    const low=phase==='partial'||phase==='rising';
    ctx.fillStyle=phase==='dipping'||low?'#376aa1':P.green;
    ctx.fillRect(cx+3,cy-(low?2:4),8,low?5:9);ctx.fillRect(cx+2,cy-2,10,5);
    if(!low){ctx.fillRect(cx+1,cy-5,3,2);ctx.fillRect(cx+9,cy-5,3,2);ctx.fillRect(cx+1,cy+4,3,2);ctx.fillRect(cx+9,cy+4,3,2);}
    ctx.fillStyle=phase==='surface'?P.darkGreen:P.water;ctx.fillRect(cx+5,cy-2,4,5);ctx.fillRect(cx+3,cy,8,1);
    if(phase==='surface'){ctx.fillStyle=P.lime;ctx.fillRect(cx+6,cy-3,2,2);ctx.fillStyle=P.white;ctx.fillRect(cx,cy+(Math.floor(frame/20)%2),2,2);}
  }
}
export function drawCroc(ctx:CanvasRenderingContext2D,x:number,y:number,w:number,right:boolean,open:boolean):void {
  ctx.save();ctx.translate(Math.round(x),Math.round(y));if(!right){ctx.translate(w,0);ctx.scale(-1,1);}
  ctx.fillStyle=P.darkGreen;ctx.fillRect(1,-4,w-16,9);ctx.fillRect(8,-6,w-27,2);ctx.fillRect(8,5,w-27,2);
  ctx.fillStyle=P.green;ctx.fillRect(5,-3,w-22,7);for(let i=8;i<w-18;i+=6)ctx.fillRect(i,-5,3,2);
  ctx.fillStyle=P.lime;ctx.fillRect(w-18,-4,7,8);ctx.fillRect(w-12,-3,11,3);ctx.fillRect(w-12,open?4:1,11,3);
  ctx.fillStyle=P.white;ctx.fillRect(w-16,-4,2,2);ctx.fillStyle=P.black;ctx.fillRect(w-15,-4,1,1);
  if(open){ctx.fillStyle=P.white;for(let i=w-10;i<w-1;i+=3){ctx.fillRect(i,0,1,2);ctx.fillRect(i,3,1,2);}}
  ctx.restore();
}
export function drawSnake(ctx:CanvasRenderingContext2D,x:number,y:number,w:number,frame:number):void {
  ctx.fillStyle=P.yellow;
  for(let i=0;i<w;i+=2)ctx.fillRect(Math.round(x+i),Math.round(y+Math.sin((i+frame/4)/3)*2)-1,3,3);
  ctx.fillStyle=P.orange;ctx.fillRect(Math.round(x),y-2,5,5);ctx.fillStyle=P.white;ctx.fillRect(Math.round(x),y-2,1,1);
}
export function drawFly(ctx:CanvasRenderingContext2D,x:number,y:number,frame:number):void {
  pixels(ctx,['w...w','ww.ww','.yyy.','..y..','.y.y.'],Math.round(x-2),y-3,{w:frame%16<8?P.white:P.blue,y:P.yellow});
}
